import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useParams, useOutletContext, useSearchParams, useNavigate } from 'react-router-dom';
import {
  IonSpinner,
  IonItem,
  IonLabel,
  IonCheckbox,
  IonSkeletonText,
  IonButton,
  IonIcon
} from '@ionic/react';
import {
  logoGithub,
  sparklesOutline,
  peopleOutline,
  checkmarkCircle,
  linkOutline
} from 'ionicons/icons';
import InviteModal from '../../components/organisms/Modals/InviteModal/InviteModal';
import LarkConnectModal from '../../components/integrations/LarkConnectModal';
import CollapsibleCard from '../../components/atoms/CollapsibleCard';
import PillButton from '../../components/shared/PillButton';
import { isClaudeOAuthToken } from '../../components/molecules/AgentModelFields/AgentModelFields';
import api from '../../services/api';
import './ProjectSettings.css';
// EXACT visual reuse of the Integrations-page rows (.integration-item /
// .integration-content / .integration-button) for the Chat section below.
import '../IntegrationsPage/IntegrationsPage.css';

// Minimum time the Save spinner stays up, so a fast save reads as a real action
// instead of a one-frame blink.
const MIN_SPINNER_MS = 1500;

// Chat integrations icon — chat-square-call (SVG Repo, CC0), currentColor so
// it inherits the card icon color like the ionicons ones.
const chatSquareCallSvg = 'data:image/svg+xml,' + encodeURIComponent('<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 15V7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M8 13V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M16 13V9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M13.0867 21.3877L13.7321 21.7697L13.0867 21.3877ZM13.6288 20.4718L12.9833 20.0898L13.6288 20.4718ZM10.3712 20.4718L9.72579 20.8539H9.72579L10.3712 20.4718ZM10.9133 21.3877L11.5587 21.0057L10.9133 21.3877ZM1.25 10.5C1.25 10.9142 1.58579 11.25 2 11.25C2.41421 11.25 2.75 10.9142 2.75 10.5H1.25ZM3.07351 15.6264C2.915 15.2437 2.47627 15.062 2.09359 15.2205C1.71091 15.379 1.52918 15.8177 1.68769 16.2004L3.07351 15.6264ZM7.78958 18.9915L7.77666 19.7413L7.78958 18.9915ZM5.08658 18.6194L4.79957 19.3123H4.79957L5.08658 18.6194ZM21.6194 15.9134L22.3123 16.2004V16.2004L21.6194 15.9134ZM16.2104 18.9915L16.1975 18.2416L16.2104 18.9915ZM18.9134 18.6194L19.2004 19.3123H19.2004L18.9134 18.6194ZM19.6125 2.7368L19.2206 3.37628L19.6125 2.7368ZM21.2632 4.38751L21.9027 3.99563V3.99563L21.2632 4.38751ZM4.38751 2.7368L3.99563 2.09732V2.09732L4.38751 2.7368ZM2.7368 4.38751L2.09732 3.99563H2.09732L2.7368 4.38751ZM9.40279 19.2098L9.77986 18.5615L9.77986 18.5615L9.40279 19.2098ZM13.7321 21.7697L14.2742 20.8539L12.9833 20.0898L12.4412 21.0057L13.7321 21.7697ZM9.72579 20.8539L10.2679 21.7697L11.5587 21.0057L11.0166 20.0898L9.72579 20.8539ZM12.4412 21.0057C12.2485 21.3313 11.7515 21.3313 11.5587 21.0057L10.2679 21.7697C11.0415 23.0767 12.9585 23.0767 13.7321 21.7697L12.4412 21.0057ZM10.5 2.75H13.5V1.25H10.5V2.75ZM21.25 10.5V11.5H22.75V10.5H21.25ZM7.8025 18.2416C6.54706 18.2199 5.88923 18.1401 5.37359 17.9265L4.79957 19.3123C5.60454 19.6457 6.52138 19.7197 7.77666 19.7413L7.8025 18.2416ZM1.68769 16.2004C2.27128 17.6093 3.39066 18.7287 4.79957 19.3123L5.3736 17.9265C4.33223 17.4951 3.50486 16.6678 3.07351 15.6264L1.68769 16.2004ZM21.25 11.5C21.25 12.6751 21.2496 13.5189 21.2042 14.1847C21.1592 14.8438 21.0726 15.2736 20.9265 15.6264L22.3123 16.2004C22.5468 15.6344 22.6505 15.0223 22.7007 14.2868C22.7504 13.5581 22.75 12.6546 22.75 11.5H21.25ZM16.2233 19.7413C17.4786 19.7197 18.3955 19.6457 19.2004 19.3123L18.6264 17.9265C18.1108 18.1401 17.4529 18.2199 16.1975 18.2416L16.2233 19.7413ZM20.9265 15.6264C20.4951 16.6678 19.6678 17.4951 18.6264 17.9265L19.2004 19.3123C20.6093 18.7287 21.7287 17.6093 22.3123 16.2004L20.9265 15.6264ZM13.5 2.75C15.1512 2.75 16.337 2.75079 17.2619 2.83873C18.1757 2.92561 18.7571 3.09223 19.2206 3.37628L20.0044 2.09732C19.2655 1.64457 18.4274 1.44279 17.4039 1.34547C16.3915 1.24921 15.1222 1.25 13.5 1.25V2.75ZM22.75 10.5C22.75 8.87781 22.7508 7.6085 22.6545 6.59611C22.5572 5.57256 22.3554 4.73445 21.9027 3.99563L20.6237 4.77938C20.9078 5.24291 21.0744 5.82434 21.1613 6.73809C21.2492 7.663 21.25 8.84876 21.25 10.5H22.75ZM19.2206 3.37628C19.7925 3.72672 20.2733 4.20752 20.6237 4.77938L21.9027 3.99563C21.4286 3.22194 20.7781 2.57144 20.0044 2.09732L19.2206 3.37628ZM10.5 1.25C8.87781 1.25 7.6085 1.24921 6.59611 1.34547C5.57256 1.44279 4.73445 1.64457 3.99563 2.09732L4.77938 3.37628C5.24291 3.09223 5.82434 2.92561 6.73809 2.83873C7.663 2.75079 8.84876 2.75 10.5 2.75V1.25ZM2.75 10.5C2.75 8.84876 2.75079 7.663 2.83873 6.73809C2.92561 5.82434 3.09223 5.24291 3.37628 4.77938L2.09732 3.99563C1.64457 4.73445 1.44279 5.57256 1.34547 6.59611C1.24921 7.6085 1.25 8.87781 1.25 10.5H2.75ZM3.99563 2.09732C3.22194 2.57144 2.57144 3.22194 2.09732 3.99563L3.37628 4.77938C3.72672 4.20752 4.20752 3.72672 4.77938 3.37628L3.99563 2.09732ZM11.0166 20.0898C10.8136 19.7468 10.6354 19.4441 10.4621 19.2063C10.2795 18.9559 10.0702 18.7304 9.77986 18.5615L9.02572 19.8582C9.07313 19.8857 9.13772 19.936 9.24985 20.0898C9.37122 20.2564 9.50835 20.4865 9.72579 20.8539L11.0166 20.0898ZM7.77666 19.7413C8.21575 19.7489 8.49387 19.7545 8.70588 19.7779C8.90399 19.7999 8.98078 19.832 9.02572 19.8582L9.77986 18.5615C9.4871 18.3912 9.18246 18.3215 8.87097 18.287C8.57339 18.2541 8.21375 18.2487 7.8025 18.2416L7.77666 19.7413ZM14.2742 20.8539C14.4916 20.4865 14.6287 20.2564 14.7501 20.0898C14.8622 19.936 14.9268 19.8857 14.9742 19.8582L14.2201 18.5615C13.9298 18.7304 13.7204 18.9559 13.5379 19.2063C13.3646 19.4441 13.1864 19.7468 12.9833 20.0898L14.2742 20.8539ZM16.1975 18.2416C15.7862 18.2487 15.4266 18.2541 15.129 18.287C14.8175 18.3215 14.5129 18.3912 14.2201 18.5615L14.9742 19.8582C15.0192 19.832 15.096 19.7999 15.2941 19.7779C15.5061 19.7545 15.7842 19.7489 16.2233 19.7413L16.1975 18.2416Z" fill="currentColor"/></svg>');

const gitlabLogoSvg = 'data:image/svg+xml,' + encodeURIComponent('<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23.955 13.587l-1.342-4.135-2.664-8.189a.455.455 0 00-.867 0L16.418 9.45H7.582L4.918 1.263a.455.455 0 00-.867 0L1.386 9.452.045 13.587a.924.924 0 00.331 1.023L12 23.054l11.624-8.443a.92.92 0 00.331-1.024" fill="#E24329"/><path d="M12 23.054L16.418 9.45H7.582L12 23.054z" fill="#FC6D26"/><path d="M12 23.054l-4.418-13.6H1.386L12 23.054z" fill="#FCA326"/><path d="M1.386 9.452L.045 13.587a.924.924 0 00.331 1.023L12 23.054 1.386 9.452z" fill="#E24329"/><path d="M12 23.054l4.418-13.6h6.196L12 23.054z" fill="#FCA326"/><path d="M22.614 9.452l1.341 4.135a.924.924 0 01-.331 1.023L12 23.054l10.614-13.602z" fill="#E24329"/></svg>');

// Each AI vendor owns EXACTLY ONE project-secret slot — claude is dual-shape
// (aiApiKey for sk-ant-api03-…, aiOAuthToken for sk-ant-oat01-…), codex →
// codexApiKey, gemini → geminiApiKey. This 1:1 mapping (matching what the deploy
// path reads per-agent) is what lets every configured agent round-trip on save
// with no phantom duplicates and nothing clobbered. `isPrimary` lets a NON-claude
// DEFAULT agent fall back to the legacy generic aiApiKey slot for pre-per-vendor
// projects, so an older codex/gemini default still shows its saved key.
const vendorKeyFromSecrets = (secrets, vendor, isPrimary) => {
  const s = secrets || {};
  const str = (x) => ((typeof x === 'string' && x) ? x : '');
  if (vendor === 'codex') return str(s.codexApiKey) || (isPrimary ? str(s.aiApiKey) : '');
  if (vendor === 'gemini') return str(s.geminiApiKey) || (isPrimary ? str(s.aiApiKey) : '');
  return str(s.aiOAuthToken) || str(s.aiApiKey); // claude
};

// The three AI vendor credential slots shown in the AI Settings card. The MODEL
// is NOT chosen here — it's part of the agent, picked at deploy time (defaults to
// the latest). This section just stores each vendor's API key / OAuth token, one
// per vendor. Mirrors the self-host renderAgentSettings implementation 1:1.
const AI_VENDORS = [
  {
    key: 'claude',
    label: 'Claude',
    placeholder: 'sk-ant-oat01-… (Claude Pro/Max)  or  sk-ant-… / API key',
    helper: (
      <>Claude subscription OAuth token (<code>sk-ant-oat01-…</code>) or an API key.
        Get an OAuth token with <code>claude setup-token</code>.</>
    ),
  },
  {
    key: 'codex',
    label: 'Codex · OpenAI',
    placeholder: 'sk-… — OpenAI API key',
    helper: <>OpenAI API key (<code>sk-…</code>) for the Codex agent.</>,
  },
  {
    key: 'gemini',
    label: 'Gemini · Google',
    placeholder: 'AIza… — Google Gemini API key',
    helper: <>Google Gemini API key (<code>AIza…</code>).</>,
  },
];

// A typed credential value we should IGNORE on save: blank, or one still showing
// the masked saved key (GET returns keys masked as prefix…suffix / prefix...suffix).
const isBlankOrMaskedCred = (raw) => {
  const v = (raw || '').trim();
  return !v || v.includes('…') || v.includes('...') || v.includes('••');
};

// Per-project permissions a NON-owner member can be granted. Reuses the
// self-host model (trigger/deploy) + apps-deploy for managed apps + admin
// (full access — the backend's canonical rule treats admin as satisfying
// EVERY action on that project; see backend selfhost-permissions.js).
// A member can always VIEW; every other action requires its flag.
const MEMBER_PERMS = [
  { key: 'trigger', label: 'Trigger', desc: 'Run existing agents' },
  { key: 'deploy', label: 'Deploy', desc: 'Deploy & configure any agent (marketplace, custom, or wrapper)' },
  { key: 'appsDeploy', label: 'Deploy apps', desc: 'Deploy managed apps' },
  { key: 'admin', label: 'Admin', desc: 'Full access — every operation on this project (implies all other permissions)' },
];
const normMemberPerms = (p) => {
  const s = p && typeof p === 'object' ? p : {};
  return Object.fromEntries(MEMBER_PERMS.map(({ key }) => [key, s[key] === true]));
};

const ProjectSettings = () => {
  const { projectId } = useParams();
  const { project, setToast, refreshProject } = useOutletContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const expandSection = searchParams.get('section');
  
  // Which card's Save is in flight ('github' | 'gitlab' | 'ai' | null) — so
  // clicking one card's Save only spins THAT card's button, not all of them.
  const [savingSection, setSavingSection] = useState(null);
  const [githubRepos, setGithubRepos] = useState([]);
  const [loadingRepos, setLoadingRepos] = useState(false);
  const [hasLoadedRepos, setHasLoadedRepos] = useState(false);
  
  const [gitlabRepos, setGitlabRepos] = useState([]);
  const [loadingGitlabRepos, setLoadingGitlabRepos] = useState(false);
  const [hasLoadedGitlabRepos, setHasLoadedGitlabRepos] = useState(false);
  
  const [selectedRepos, setSelectedRepos] = useState([]);
  const [selectedGitlabRepos, setSelectedGitlabRepos] = useState([]);
  
  // Per-vendor typed credential inputs. Each starts EMPTY; a saved key is shown
  // only in the field's placeholder (masked), so a blank input means "keep the
  // saved value". The MODEL is not chosen here — it's part of the agent, picked
  // at deploy time (defaults to the latest). Mirrors self-host renderAgentSettings.
  const [credInputs, setCredInputs] = useState({ claude: '', codex: '', gemini: '' });
  // Which vendor's per-field Remove is in flight (for its inline spinner).
  const [removingVendor, setRemovingVendor] = useState(null);

  // Members & access — the project's members (owner + invited), each with a
  // per-project permission set. Owner is full-access and shown read-only.
  const [members, setMembers] = useState([]);
  const [invites, setInvites] = useState([]); // pending (not-yet-accepted) invitations
  const [membersLoading, setMembersLoading] = useState(false);
  const [membersError, setMembersError] = useState(null);
  const [inviteOpen, setInviteOpen] = useState(false);
  const [inviteSubmitting, setInviteSubmitting] = useState(false);
  const [savingPermUser, setSavingPermUser] = useState(null);
  const inviteBtnRef = useRef(null);

  // Chat integrations — THIS PROJECT'S OWN Lark app (per-project Copilot
  // override). Loaded lazily on first expand of the Chat card.
  const [larkOverride, setLarkOverride] = useState(null); // {connected, appId, eventRequestUrl, ...}
  const [larkOverrideLoading, setLarkOverrideLoading] = useState(false);
  const [hasLoadedLarkOverride, setHasLoadedLarkOverride] = useState(false);
  const [larkModalOpen, setLarkModalOpen] = useState(false);
  const [larkDisconnecting, setLarkDisconnecting] = useState(false);
  // Slack per-project OAuth override — the cloud twin of the self-host socket
  // connect: one Zibby Slack app, OAuth-installed, its workspace routed to THIS
  // project's Copilot (one workspace ⇒ one project). {connected, team, ...}.
  const [slackOverride, setSlackOverride] = useState(null);
  const [slackOverrideLoading, setSlackOverrideLoading] = useState(false);
  const [hasLoadedSlackOverride, setHasLoadedSlackOverride] = useState(false);
  const [slackDisconnecting, setSlackDisconnecting] = useState(false);

  const loadLarkOverride = useCallback(async () => {
    if (!projectId) return;
    setLarkOverrideLoading(true);
    try {
      const st = await api.get(`/lark/status?projectId=${encodeURIComponent(projectId)}`);
      setLarkOverride(st || {});
    } catch {
      setLarkOverride({});
    } finally {
      setLarkOverrideLoading(false);
      setHasLoadedLarkOverride(true);
    }
  }, [projectId]);

  const disconnectLarkOverride = async () => {
    if (!window.confirm("Disconnect this project's own Lark app? The account-level connection (if any) becomes the fallback.")) return;
    setLarkDisconnecting(true);
    try {
      await api.post('/lark/disconnect', { overrideProjectId: projectId });
      setToast?.({ show: true, message: 'Project Lark app disconnected.', color: 'success' });
      await loadLarkOverride();
    } catch (e) {
      setToast?.({ show: true, message: e?.message || 'Failed to disconnect.', color: 'danger' });
    } finally {
      setLarkDisconnecting(false);
    }
  };

  const loadSlackOverride = useCallback(async () => {
    if (!projectId) return;
    setSlackOverrideLoading(true);
    try {
      const st = await api.get(`/slack/status?projectId=${encodeURIComponent(projectId)}`);
      setSlackOverride(st || {});
    } catch {
      setSlackOverride({});
    } finally {
      setSlackOverrideLoading(false);
      setHasLoadedSlackOverride(true);
    }
  }, [projectId]);

  // Connect this project's Slack via OAuth — full-page redirect to Slack's
  // install screen; the callback binds the workspace to this project's Copilot
  // and redirects back here with ?slack=success. Mirrors the account-level Slack
  // OAuth, just project-scoped (the backend reads ?projectId from the state).
  const connectSlackOverride = async () => {
    if (!projectId) return;
    try {
      const returnTo = `/projects/${projectId}/settings?section=chat&slack=success`;
      const data = await api.get(`/slack/oauth/start?projectId=${encodeURIComponent(projectId)}&returnTo=${encodeURIComponent(returnTo)}`);
      if (data?.authUrl) window.location.href = data.authUrl;
      else throw new Error(data?.error || 'Could not start Slack connect.');
    } catch (e) {
      setToast?.({ show: true, message: e?.message || 'Failed to start Slack connect.', color: 'danger' });
    }
  };

  const disconnectSlackOverride = async () => {
    if (!window.confirm("Disconnect this project's Slack app? The account default stays the fallback.")) return;
    setSlackDisconnecting(true);
    try {
      await api.post('/slack/disconnect', { overrideProjectId: projectId });
      setToast?.({ show: true, message: 'Project Slack app disconnected.', color: 'success' });
      await loadSlackOverride();
    } catch (e) {
      setToast?.({ show: true, message: e?.message || 'Failed to disconnect.', color: 'danger' });
    } finally {
      setSlackDisconnecting(false);
    }
  };

  // OAuth return / deep-link into Chat: the card renders expanded via
  // defaultExpanded (onToggle doesn't fire on mount), so load both chat overrides
  // here and surface the Slack connect result once.
  const slackToastRef = useRef(false);
  useEffect(() => {
    if (expandSection !== 'chat') return;
    if (!hasLoadedLarkOverride) loadLarkOverride();
    if (!hasLoadedSlackOverride) loadSlackOverride();
    if (searchParams.get('slack') === 'success' && !slackToastRef.current) {
      slackToastRef.current = true;
      setToast?.({ show: true, message: 'Slack connected to this project.', color: 'success' });
    }
  }, [expandSection, hasLoadedLarkOverride, hasLoadedSlackOverride, loadLarkOverride, loadSlackOverride, searchParams, setToast]);

  // OWNER-ONLY page. Project settings (integrations, selected repos, AI
  // credentials) belong to the project owner alone; invited members must not
  // reach this page. `project.isOwner` is set authoritatively by the backend
  // (GET /projects/:id). While the project is still loading it's undefined —
  // only redirect once we KNOW the viewer is a non-owner (=== false), so the
  // owner never sees a flash-redirect. The backend also 403s the write paths,
  // so this is UX; it isn't the security boundary.
  useEffect(() => {
    if (project && project.isOwner === false) {
      setToast?.({
        show: true,
        message: 'Only the project owner can view project settings.',
        color: 'warning',
      });
      navigate(`/projects/${projectId}`, { replace: true });
    }
  }, [project, projectId, navigate, setToast]);

  useEffect(() => {
    if (project) {
      if (project.githubRepos && Array.isArray(project.githubRepos)) {
        setSelectedRepos(project.githubRepos);
      } else if (project.githubRepo) {
        setSelectedRepos([project.githubRepo]);
      } else {
        setSelectedRepos([]);
      }
      
      if (project.gitlabRepos && Array.isArray(project.gitlabRepos)) {
        setSelectedGitlabRepos(project.gitlabRepos);
      } else {
        setSelectedGitlabRepos([]);
      }

      // A fresh project load re-seeds authoritative state — clear any in-progress
      // credential typing so the fields show the newly-saved masked placeholders.
      setCredInputs({ claude: '', codex: '', gemini: '' });
    }
  }, [project, projectId]);

  // ── Members & access ────────────────────────────────────────────────────────
  const loadMembers = useCallback(async () => {
    if (!projectId) return;
    setMembersLoading(true);
    setMembersError(null);
    try {
      // Members (accepted) AND pending invitations, so the owner sees invited
      // users who haven't accepted yet — same as the InviteModal.
      const [mData, iData] = await Promise.all([
        api.get(`/projects/${projectId}/members`),
        api.get(`/projects/${projectId}/invitations`).catch(() => ({ invitations: [] })),
      ]);
      setMembers(Array.isArray(mData?.members) ? mData.members : []);
      setInvites((Array.isArray(iData?.invitations) ? iData.invitations : []).filter((inv) => inv.status === 'pending'));
    } catch (e) {
      setMembersError(e?.message || 'Failed to load members');
      setMembers([]);
      setInvites([]);
    } finally {
      setMembersLoading(false);
    }
  }, [projectId]);

  const cancelInvite = async (inv) => {
    try {
      await api.request(`/invitations/${inv.invitationId}`, { method: 'DELETE' });
      setInvites((prev) => prev.filter((x) => x.invitationId !== inv.invitationId));
    } catch (e) {
      setToast?.({ show: true, message: e?.message || 'Could not cancel invite', color: 'danger' });
    }
  };

  useEffect(() => {
    if (project && project.isOwner !== false) loadMembers();
  }, [project, loadMembers]);

  const handleInvite = async (emails) => {
    setInviteSubmitting(true);
    try {
      const data = await api.post(`/projects/${projectId}/invitations`, { emails });
      setInviteOpen(false);
      loadMembers();
      return data;
    } catch (error) {
      throw error;
    } finally {
      setInviteSubmitting(false);
    }
  };

  // Optimistic per-project permission toggle → PATCH the membership row.
  const togglePermission = async (member, key) => {
    const current = normMemberPerms(member.permissions);
    const next = { ...current, [key]: !current[key] };
    setSavingPermUser(member.userId);
    setMembers((prev) => prev.map((m) => (m.userId === member.userId ? { ...m, permissions: next } : m)));
    try {
      const r = await api.request(`/projects/${projectId}/members/${member.userId}`, {
        method: 'PATCH',
        body: { permissions: next },
      });
      const saved = r?.permissions || next;
      setMembers((prev) => prev.map((m) => (m.userId === member.userId ? { ...m, permissions: saved } : m)));
    } catch (e) {
      // revert on failure
      setMembers((prev) => prev.map((m) => (m.userId === member.userId ? { ...m, permissions: current } : m)));
      setToast?.({ show: true, message: e?.message || 'Could not update permission', color: 'danger' });
    } finally {
      setSavingPermUser(null);
    }
  };

  const removeMember = async (member) => {
    // eslint-disable-next-line no-restricted-globals
    if (!window.confirm(`Remove ${member.name || member.email || 'this member'} from the project? They lose access immediately.`)) return;
    try {
      await api.request(`/projects/${projectId}/members/${member.userId}`, { method: 'DELETE' });
      setMembers((prev) => prev.filter((m) => m.userId !== member.userId));
    } catch (e) {
      setToast?.({ show: true, message: e?.message || 'Could not remove member', color: 'danger' });
    }
  };

  const loadGithubRepos = async () => {
    if (hasLoadedRepos) return;
    
    setLoadingRepos(true);
    try {
      // Two-level repo model: a project may only pick from the INTEGRATION-level
      // MASTER allowlist (integration.metadata.selectedRepos, set on the
      // Integrations page), NOT every repo the token can see. Read the master
      // from status. When a master IS configured, those are the options. When
      // it's empty ("no master → allow all", backend gating is opt-in) we fall
      // back to the full token repo list so the project can still pick.
      const status = await api.get(`/github/status?projectId=${encodeURIComponent(projectId)}`).catch(() => ({}));
      const master = Array.isArray(status?.selectedRepos) ? status.selectedRepos : [];
      if (master.length > 0) {
        setGithubRepos(master.map((full_name) => ({ full_name })));
        setHasLoadedRepos(true);
        return;
      }
      // Scope to THIS project so the backend returns the OWNER's repos (never
      // the viewer's own account's).
      const data = await api.get(`/github/repos?projectId=${encodeURIComponent(projectId)}`);
      console.log('📦 GitHub repos loaded:', data.repos?.length || 0, 'repos');
      const loaded = data.repos || [];
      setGithubRepos(loaded);
      // Only LOCK the load when we actually got repos. An empty result — a
      // transient backend error swallowed to [], GitHub not yet connected, or
      // a race right after reconnect — must stay retryable. Otherwise the very
      // first empty/failed fetch sticks for the whole session and even
      // reconnecting GitHub can't recover it without a full page reload (the
      // bug: re-expanding the panel short-circuits on hasLoadedRepos and never
      // re-hits /github/repos).
      if (loaded.length > 0) setHasLoadedRepos(true);
      
      // Only warn when the token EXPIRED (GitHub WAS connected). A
      // not-connected response (needsSetup) is conveyed by the inline
      // "connect in Integrations" message — no toast for that.
      if (data.needsReconnect) {
        setToast({
          show: true,
          message: data.message || 'Only public repositories visible. Reconnect GitHub to access private repos.',
          color: 'warning',
          duration: 8000
        });
      }
    } catch (error) {
      console.error('❌ Error loading GitHub repos:', error);
      setGithubRepos([]);
      // Do NOT mark loaded on error — leave hasLoadedRepos false so the next
      // expand retries instead of permanently showing "No repositories".
      // Don't toast when GitHub simply isn't connected (auth / not-found) — the
      // inline "connect in Integrations" message already says so. Only a genuine
      // server / network failure surfaces a toast.
      const status = error?.status || error?.response?.status;
      if (!status || status >= 500) {
        setToast({
          show: true,
          message: 'Failed to load GitHub repositories. Please try again.',
          color: 'danger'
        });
      }
    } finally {
      setLoadingRepos(false);
    }
  };

  const handleRepoToggle = (repoFullName) => {
    setSelectedRepos(prev => {
      if (prev.includes(repoFullName)) {
        return prev.filter(r => r !== repoFullName);
      } else {
        return [...prev, repoFullName];
      }
    });
  };

  const loadGitlabRepos = async () => {
    if (hasLoadedGitlabRepos) return;
    
    setLoadingGitlabRepos(true);
    try {
      // Two-level repo model (see loadGithubRepos): options = the INTEGRATION
      // MASTER allowlist when configured, else fall back to all token repos.
      const status = await api.get(`/gitlab/status?projectId=${encodeURIComponent(projectId)}`).catch(() => ({}));
      const master = Array.isArray(status?.selectedRepos) ? status.selectedRepos : [];
      if (master.length > 0) {
        // Master entries are full-path strings (no instance pin) — render as
        // plain rows; matching falls back to name-only (gitlabRepoMatches).
        setGitlabRepos(master.map((full_name) => ({ full_name })));
        setHasLoadedGitlabRepos(true);
        return;
      }
      // Scope to THIS project so the backend returns the OWNER's repos (never
      // the viewer's own account's).
      const data = await api.get(`/gitlab/repos?projectId=${encodeURIComponent(projectId)}`);
      console.log('📦 GitLab repos loaded:', data.repos?.length || 0, 'repos');
      setGitlabRepos(data.repos || []);
      setHasLoadedGitlabRepos(true);
      
      // Only warn when a token EXPIRED (GitLab WAS connected). A not-connected
      // response (needsSetup) is conveyed by the inline "connect in
      // Integrations" message — no toast for that.
      if (data.needsReconnect) {
        setToast({
          show: true,
          message: data.message || 'GitLab token expired. Please reconnect GitLab.',
          color: 'warning',
          duration: 8000
        });
      }
    } catch (error) {
      console.error('Error loading GitLab repos:', error);
      setGitlabRepos([]);
      setHasLoadedGitlabRepos(true);
      // Don't toast when GitLab simply isn't connected (auth / not-found) — the
      // inline "connect in Integrations" message already says so. Only a genuine
      // server / network failure surfaces a toast.
      const status = error?.status || error?.response?.status;
      if (!status || status >= 500) {
        setToast({
          show: true,
          message: 'Failed to load GitLab repositories. Please try again.',
          color: 'danger'
        });
      }
    } finally {
      setLoadingGitlabRepos(false);
    }
  };

  // A selected entry matches a list repo by full_name AND (when present)
  // integrationId — so the same path on a cloud vs a self-hosted instance are
  // distinct. Legacy selections (no integrationId stored) match by name only.
  const gitlabRepoMatches = (selected, repo) => {
    const selName = typeof selected === 'string' ? selected : selected.full_name;
    if (selName !== repo.full_name) return false;
    // Match by name only when either side lacks an instance pin — a legacy
    // string selection (no integrationId) OR a master-derived option (the
    // account-level allowlist stores full-path strings without an instance pin).
    return !selected.integrationId || !repo.integrationId || selected.integrationId === repo.integrationId;
  };

  const handleGitlabRepoToggle = (repo) => {
    setSelectedGitlabRepos(prev => {
      if (prev.some(r => gitlabRepoMatches(r, repo))) {
        return prev.filter(r => !gitlabRepoMatches(r, repo));
      }
      return [...prev, {
        full_name: repo.full_name,
        default_branch: repo.default_branch || 'main',
        // Pin which connected instance this repo belongs to so reviews/MRs route
        // to the right GitLab and a same-named repo on the other instance stays
        // separate.
        integrationId: repo.integrationId,
        instanceHost: repo.instanceHost,
      }];
    });
  };

  // Repo-selection save (GitHub / GitLab cards). Sends ONLY the repo arrays — the
  // PUT is a partial update (backend buildProjectUpdates only writes fields it
  // sees), so this never touches the project's AI credentials or default agent.
  const persistSettings = async (overrides = {}, section = 'github') => {
    setSavingSection(section);
    // Keep the spinner up for a minimum beat so a fast save reads as a real
    // action instead of a one-frame blink.
    const startedAt = Date.now();
    try {
      const updatePayload = {
        githubRepos: selectedRepos,
        gitlabRepos: selectedGitlabRepos,
        ...overrides
      };

      await api.put(`/projects/${projectId}`, updatePayload);
      // Re-fetch so the form re-seeds from the saved state without a manual reload.
      await refreshProject?.();
      setToast({
        show: true,
        message: 'Settings saved successfully!',
        color: 'success'
      });
    } catch (error) {
      console.error('Error saving settings:', error);
      setToast({
        show: true,
        message: 'Failed to save settings',
        color: 'danger'
      });
    } finally {
      const elapsed = Date.now() - startedAt;
      if (elapsed < MIN_SPINNER_MS) await new Promise((r) => setTimeout(r, MIN_SPINNER_MS - elapsed));
      setSavingSection(null);
    }
  };

  const handleSave = (section = 'github') => persistSettings({}, section);

  // Read a vendor's SAVED (masked) key from the project — drives the "· saved"
  // placeholder + whether a per-field Remove shows. Not primary → no legacy slot
  // fallback, so codex/gemini only reflect their own slot.
  const savedKeyFor = (vendor) => vendorKeyFromSecrets(project?.secrets, vendor, false);

  // Save AI credentials — one PUT carrying only the vendor slots the operator
  // actually typed (blank/masked = keep). Routes each typed key to its OWN
  // project-secret slot; a claude sk-ant-oat01-… → aiOAuthToken (clears aiApiKey),
  // any other claude key → aiApiKey (clears aiOAuthToken), codex → codexApiKey,
  // gemini → geminiApiKey. Sets the project default agent to the first vendor that
  // HAS a key (model 'auto' = latest, actually chosen in the deploy modal).
  const handleSaveAi = async () => {
    setSavingSection('ai');
    const startedAt = Date.now();
    try {
      const secretsToUpdate = {};
      const setVendorKey = (vendor, raw) => {
        if (isBlankOrMaskedCred(raw)) return; // blank/masked → keep saved value
        const v = raw.trim();
        if (vendor === 'codex') { secretsToUpdate.codexApiKey = v; }
        else if (vendor === 'gemini') { secretsToUpdate.geminiApiKey = v; }
        else if (isClaudeOAuthToken(v)) { secretsToUpdate.aiOAuthToken = v; secretsToUpdate.aiApiKey = ''; }
        else { secretsToUpdate.aiApiKey = v; secretsToUpdate.aiOAuthToken = ''; }
      };
      ['claude', 'codex', 'gemini'].forEach((v) => setVendorKey(v, credInputs[v]));

      const payload = {};
      if (Object.keys(secretsToUpdate).length > 0) payload.secrets = secretsToUpdate;
      // Deploy-fallback default agent = first vendor that HAS a key (saved or just
      // typed). model 'auto' = latest; the real model is chosen in the deploy modal.
      const has = (v) => !!savedKeyFor(v) || !isBlankOrMaskedCred(credInputs[v]);
      const defAgent = has('claude') ? 'claude' : has('codex') ? 'codex' : has('gemini') ? 'gemini' : '';
      if (defAgent) { payload.aiAgent = defAgent; payload.aiModel = 'auto'; }

      if (!payload.secrets && !payload.aiAgent) {
        setToast({ show: true, message: 'Nothing to save', color: 'success' });
        return;
      }

      await api.put(`/projects/${projectId}`, payload);
      setCredInputs({ claude: '', codex: '', gemini: '' });
      // Re-fetch so the fields re-seed with the newly-saved masked placeholders.
      await refreshProject?.();
      setToast({ show: true, message: 'Settings saved successfully!', color: 'success' });
    } catch (error) {
      console.error('Error saving AI credentials:', error);
      setToast({ show: true, message: 'Failed to save settings', color: 'danger' });
    } finally {
      const elapsed = Date.now() - startedAt;
      if (elapsed < MIN_SPINNER_MS) await new Promise((r) => setTimeout(r, MIN_SPINNER_MS - elapsed));
      setSavingSection(null);
    }
  };

  // Per-field Remove — clears just ONE vendor's slot(s) immediately (its own PUT),
  // then refetches. claude clears BOTH shapes (aiApiKey + aiOAuthToken); '' → the
  // backend deletes the encrypted field.
  const clearSlotFor = (vendor) => {
    if (vendor === 'codex') return { codexApiKey: '' };
    if (vendor === 'gemini') return { geminiApiKey: '' };
    return { aiApiKey: '', aiOAuthToken: '' }; // claude (dual-shape)
  };
  const handleRemoveVendor = async (vendor) => {
    // eslint-disable-next-line no-restricted-globals
    if (!window.confirm(`Remove the saved ${vendor} credential? Agents using it will fail to run until a new one is set.`)) return;
    setRemovingVendor(vendor);
    try {
      await api.put(`/projects/${projectId}`, { secrets: clearSlotFor(vendor) });
      setCredInputs((p) => ({ ...p, [vendor]: '' }));
      await refreshProject?.();
      setToast({ show: true, message: `${vendor} credential removed`, color: 'success' });
    } catch (err) {
      console.error('Error removing AI credential:', err);
      setToast({ show: true, message: err?.message || 'Failed to remove credential', color: 'danger' });
    } finally {
      setRemovingVendor(null);
    }
  };

  if (!project) {
    return (
      <div className="project-settings-page">
        <div className="settings-content">
          {[0, 1, 2].map((i) => (
            <div className="collapsible-card settings-skeleton-card" key={i} aria-hidden="true">
              <div className="collapsible-card-header">
                <div className="collapsible-card-header-left">
                  <IonSkeletonText animated className="settings-skeleton-chevron" />
                  <div className="collapsible-card-icon">
                    <IonSkeletonText animated className="settings-skeleton-icon" />
                  </div>
                  <div className="collapsible-card-title-group">
                    <IonSkeletonText animated className="settings-skeleton-title" />
                    <IonSkeletonText animated className="settings-skeleton-subtitle" />
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div className="project-settings-page">

      <div className="settings-content">
        {/* Members & access — incremental add: shows the project's members and
            their PER-PROJECT permissions. The invite flow itself is unchanged —
            the existing InviteModal is reused as-is. */}
        <CollapsibleCard
          title="Members & access"
          subtitle="People with access to this project and their per-project permissions."
          icon={peopleOutline}
          defaultExpanded={expandSection === 'members'}
          showHeaderActionsOnlyWhenExpanded={true}
          headerActions={
            <PillButton onClick={() => setInviteOpen(true)}>Invite</PillButton>
          }
        >
          {membersLoading ? (
            <div className="repos-loading">
              <IonSpinner />
              <p>Loading members…</p>
            </div>
          ) : membersError ? (
            <p className="no-repos">Couldn’t load members: {membersError}</p>
          ) : members.length === 0 && invites.length === 0 ? (
            <p className="no-repos">No members yet. Use Invite to add one.</p>
          ) : (
            <div className="members-list">
              {members.map((m) => {
                const isOwner = m.role === 'owner';
                const perms = normMemberPerms(m.permissions);
                return (
                  <div className="member-row" key={m.userId}>
                    <div className="member-id">
                      <div className="member-name">{m.name || m.email || m.userId}</div>
                      {m.email && m.name && <div className="member-email">{m.email}</div>}
                    </div>
                    <div className="member-perms">
                      {isOwner ? (
                        <span className="member-owner-badge">Owner · full access</span>
                      ) : (
                        MEMBER_PERMS.map((p) => (
                          <button
                            key={p.key}
                            type="button"
                            title={p.desc}
                            className={`member-perm-chip${perms[p.key] ? ' on' : ''}`}
                            disabled={savingPermUser === m.userId}
                            onClick={() => togglePermission(m, p.key)}
                          >
                            <span className="member-perm-dot" />
                            {p.label}
                          </button>
                        ))
                      )}
                    </div>
                    <div className="member-actions">
                      {!isOwner && (
                        <button type="button" className="member-remove" onClick={() => removeMember(m)}>
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                );
              })}
              {invites.map((inv) => (
                <div className="member-row" key={inv.invitationId}>
                  <div className="member-id">
                    <div className="member-name">{inv.email}</div>
                    <div className="member-email">Invited · pending</div>
                  </div>
                  <div className="member-perms">
                    <span className="member-pending-badge">Awaiting accept</span>
                  </div>
                  <div className="member-actions">
                    <button type="button" className="member-remove" onClick={() => cancelInvite(inv)}>
                      Cancel
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
        </CollapsibleCard>

        {/* GitHub Integration */}
        <CollapsibleCard
          title="GitHub Repository"
          subtitle="Select GitHub repositories for this project. AI agents will create pull requests here."
          icon={logoGithub}
          defaultExpanded={false}
          lazyLoad={true}
          showHeaderActionsOnlyWhenExpanded={true}
          onToggle={(isExpanded) => {
            if (isExpanded && !hasLoadedRepos) {
              loadGithubRepos();
            }
          }}
          headerActions={
            <PillButton
              onClick={() => handleSave('github')}
              loading={savingSection === 'github'}
              disabled={savingSection === 'github' || loadingRepos}
            >
              Save
            </PillButton>
          }
        >
          {loadingRepos ? (
            <div className="repos-loading">
              <IonSpinner />
              <p>Loading repositories...</p>
            </div>
          ) : (
            <div className="repos-list">
              {githubRepos.length === 0 ? (
                <p className="no-repos">No repositories available. Please connect GitHub in{' '}
                  <button type="button" className="link-inline" onClick={() => navigate('/integrations')}>Integrations</button>.
                </p>
              ) : (
                githubRepos.map((repo) => (
                  <IonItem key={repo.full_name} className="repo-item">
                    <IonCheckbox
                      checked={selectedRepos.includes(repo.full_name)}
                      onIonChange={() => handleRepoToggle(repo.full_name)}
                      slot="start"
                    />
                    <IonLabel>
                      <h3>{repo.full_name}</h3>
                    </IonLabel>
                    {repo.private && <span className="repo-badge" slot="end">Private</span>}
                  </IonItem>
                ))
              )}
            </div>
          )}
        </CollapsibleCard>

        {/* GitLab Integration */}
        <CollapsibleCard
          title="GitLab Repository"
          subtitle="Select GitLab repositories for this project. AI agents will create merge requests here."
          icon={gitlabLogoSvg}
          defaultExpanded={false}
          lazyLoad={true}
          showHeaderActionsOnlyWhenExpanded={true}
          onToggle={(isExpanded) => {
            if (isExpanded && !hasLoadedGitlabRepos) {
              loadGitlabRepos();
            }
          }}
          headerActions={
            <PillButton
              onClick={() => handleSave('gitlab')}
              loading={savingSection === 'gitlab'}
              disabled={savingSection === 'gitlab' || loadingGitlabRepos}
            >
              Save
            </PillButton>
          }
        >
          {loadingGitlabRepos ? (
            <div className="repos-loading">
              <IonSpinner />
              <p>Loading repositories...</p>
            </div>
          ) : (
            <div className="repos-list">
              {gitlabRepos.length === 0 ? (
                <p className="no-repos">No repositories available. Please connect GitLab in{' '}
                  <button type="button" className="link-inline" onClick={() => navigate('/integrations')}>Integrations</button>.
                </p>
              ) : (
                gitlabRepos.map((repo) => (
                  <IonItem key={`${repo.integrationId || ''}:${repo.full_name}`} className="repo-item">
                    <IonCheckbox
                      checked={selectedGitlabRepos.some(r => gitlabRepoMatches(r, repo))}
                      onIonChange={() => handleGitlabRepoToggle(repo)}
                      slot="start"
                    />
                    <IonLabel>
                      <h3>{repo.full_name}</h3>
                      {repo.instanceHost && <p className="repo-instance">{repo.instanceHost}</p>}
                    </IonLabel>
                    {repo.private && <span className="repo-badge" slot="end">Private</span>}
                  </IonItem>
                ))
              )}
            </div>
          )}
        </CollapsibleCard>

        {/* AI Settings — one CREDENTIAL per vendor (Claude / Codex / Gemini). The
            MODEL is not chosen here; agents pick it at deploy time (defaults to the
            latest). Mirrors the self-host renderAgentSettings implementation. */}
        <CollapsibleCard
          title="AI Settings"
          subtitle="One credential per vendor. Agents pick their model at deploy time (defaults to the latest)."
          icon={sparklesOutline}
          defaultExpanded={expandSection === 'ai'}
          showHeaderActionsOnlyWhenExpanded={true}
          headerActions={
            <PillButton
              onClick={handleSaveAi}
              loading={savingSection === 'ai'}
              disabled={savingSection === 'ai'}
            >
              Save
            </PillButton>
          }
        >
          <div className="ai-settings-form">
            {AI_VENDORS.map((v) => {
              // GET returns a saved key MASKED as prefix…suffix — show it in the
              // placeholder so the operator can tell which key is stored, and offer
              // a per-field Remove that clears just this vendor's slot.
              const savedMasked = savedKeyFor(v.key);
              const isSaved = !!savedMasked;
              // ONE mask shape, no prose: `abcd**********wxyz` (first four, ten
              // stars, last four — self-host dashboard parity). The mask itself
              // says a key is saved; the optional input says leaving it blank
              // keeps it.
              const placeholder = isSaved
                ? savedMasked.replace(/(?:\.{3}|…|\*+|•+)/, '**********')
                : v.placeholder;
              return (
                <div className="ai-cred-field" key={v.key}>
                  <div className="ai-cred-field-header">
                    <span className="ai-cred-field-label">{v.label}</span>
                    {isSaved && (
                      <button
                        type="button"
                        className="ai-settings-remove-btn"
                        onClick={() => handleRemoveVendor(v.key)}
                        disabled={removingVendor === v.key || savingSection === 'ai'}
                      >
                        {removingVendor === v.key ? 'Removing…' : 'Remove'}
                      </button>
                    )}
                  </div>
                  <input
                    className={`ai-native-input${isSaved ? ' saved' : ''}`}
                    type="password"
                    value={credInputs[v.key]}
                    placeholder={placeholder}
                    onChange={(e) => setCredInputs((p) => ({ ...p, [v.key]: e.target.value }))}
                    autoComplete="new-password"
                    spellCheck={false}
                    disabled={savingSection === 'ai'}
                  />
                  <p className="ai-cred-field-hint">{v.helper}</p>
                </div>
              );
            })}
          </div>
        </CollapsibleCard>

        {/* Chat integrations — THIS PROJECT'S OWN chat apps (per-project Copilot
            override). Both work end-to-end on cloud: Slack via OAuth (one Zibby
            app, workspace routed to this project — one workspace ⇒ one project),
            Lark via the project's own app. Self-host adds the Socket-Mode Slack
            variant. Account default stays the fallback. */}
        <CollapsibleCard
          title="Chat integrations"
          subtitle="This project's own Slack + Lark apps route to this project's Copilot. The account default stays the fallback."
          icon={chatSquareCallSvg}
          defaultExpanded={expandSection === 'chat'}
          lazyLoad={true}
          onToggle={(isExpanded) => {
            if (isExpanded && !hasLoadedLarkOverride) loadLarkOverride();
            if (isExpanded && !hasLoadedSlackOverride) loadSlackOverride();
          }}
        >
          {(larkOverrideLoading || slackOverrideLoading) ? (
            <div className="repos-loading">
              <IonSpinner />
              <p>Loading…</p>
            </div>
          ) : (
            /* EXACT Integrations-page rows — same .integration-item markup,
               icons, and Connect/Connected buttons as /integrations; only the
               wiring is project-scoped. */
            <>
              <IonItem className="integration-item">
                <div className="slack-icon-wrapper" slot="start">
                  <svg className="integration-icon slack" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" style={{ width: 26, height: 26 }}>
                    <path d="M5.042 15.165a2.528 2.528 0 0 1-2.52 2.523A2.528 2.528 0 0 1 0 15.165a2.527 2.527 0 0 1 2.522-2.52h2.52v2.52zm1.271 0a2.527 2.527 0 0 1 2.521-2.52 2.527 2.527 0 0 1 2.521 2.52v6.313A2.528 2.528 0 0 1 8.834 24a2.528 2.528 0 0 1-2.521-2.522v-6.313z" fill="#E01E5A"/>
                    <path d="M8.834 5.042a2.528 2.528 0 0 1-2.521-2.52A2.528 2.528 0 0 1 8.834 0a2.528 2.528 0 0 1 2.521 2.522v2.52H8.834zm0 1.271a2.528 2.528 0 0 1 2.521 2.521 2.528 2.528 0 0 1-2.521 2.521H2.522A2.528 2.528 0 0 1 0 8.834a2.528 2.528 0 0 1 2.522-2.521h6.312z" fill="#36C5F0"/>
                    <path d="M18.956 8.834a2.528 2.528 0 0 1 2.522-2.521A2.528 2.528 0 0 1 24 8.834a2.528 2.528 0 0 1-2.522 2.521h-2.522V8.834zm-1.27 0a2.528 2.528 0 0 1-2.522 2.521 2.527 2.527 0 0 1-2.521-2.521V2.522A2.527 2.527 0 0 1 15.165 0a2.528 2.528 0 0 1 2.522 2.522v6.312z" fill="#2EB67D"/>
                    <path d="M15.165 18.956a2.528 2.528 0 0 1 2.522 2.522A2.528 2.528 0 0 1 15.165 24a2.527 2.527 0 0 1-2.521-2.522v-2.522h2.521zm0-1.27a2.527 2.527 0 0 1-2.521-2.522 2.528 2.528 0 0 1 2.521-2.522h6.313A2.528 2.528 0 0 1 24 15.165a2.528 2.528 0 0 1-2.522 2.521h-6.313z" fill="#ECB22E"/>
                  </svg>
                </div>
                <div className="integration-content">
                  <h3>Slack</h3>
                  <p>{slackOverride?.connected
                    ? `Connected to ${slackOverride.team || 'your workspace'} — this project's own Slack routes to its Copilot`
                    : "Connect this project's Slack workspace — its messages route to this project's Copilot"}</p>
                </div>
                <IonButton
                  className={`integration-button ${slackOverride?.connected ? 'connected' : 'connect'}`}
                  slot="end"
                  disabled={slackDisconnecting}
                  onClick={(e) => {
                    e.stopPropagation();
                    slackOverride?.connected ? disconnectSlackOverride() : connectSlackOverride();
                  }}
                >
                  <IonIcon icon={slackOverride?.connected ? checkmarkCircle : linkOutline} slot="start" />
                  {slackOverride?.connected ? 'Connected' : 'Connect'}
                </IonButton>
              </IonItem>
              <IonItem className="integration-item">
                <div className="lark-icon-wrapper" slot="start">
                  <svg className="integration-icon lark" viewBox="62.16 94.5 407.87 324.19" xmlns="http://www.w3.org/2000/svg" style={{ width: 26, height: 26 }}>
                    <path d="M274.18 264.785q.515-.517 1.03-1.027c.685-.688 1.372-1.258 2.056-1.945l1.37-1.372 4.118-4.113 5.598-5.601 4.8-4.797 4.575-4.457 4.796-4.688 4.344-4.344 6.059-6.054c1.14-1.145 2.285-2.29 3.543-3.317 2.168-2.054 4.457-4 6.855-5.828 2.172-1.715 4.344-3.312 6.516-4.914 3.082-2.172 6.398-4.344 9.71-6.285 3.204-1.941 6.63-3.656 10.06-5.371 3.199-1.602 6.515-2.973 9.827-4.23 1.829-.684 3.774-1.372 5.602-2.055.914-.344 1.941-.688 2.856-.914-8.57-33.715-24.227-64.575-45.258-90.86-4.114-5.14-10.399-8.113-17.028-8.113H130.754c-3.203 0-4.457 4-1.945 5.941 59.543 43.66 109.144 99.887 145.03 164.801 0-.226.227-.34.34-.457m0 0" fill="#00d6b9"/>
                    <path d="M204.79 418.691c90.288 0 169.03-49.828 210.058-123.543 1.488-2.628 2.859-5.257 4.23-7.882q-3.087 6-6.86 11.312l-2.741 3.77c-1.141 1.488-2.399 2.972-3.657 4.457-1.03 1.144-2.058 2.285-3.086 3.316-2.058 2.172-4.343 4.227-6.629 6.172a53 53 0 0 1-3.886 3.2c-1.598 1.144-3.086 2.284-4.684 3.429-1.031.683-2.058 1.371-3.086 1.941-1.144.684-2.172 1.258-3.316 1.942a131 131 0 0 1-6.969 3.543c-2.059.918-4.117 1.828-6.289 2.515-2.285.801-4.57 1.602-6.969 2.285-3.543.914-7.086 1.715-10.742 2.286-2.629.457-5.258.687-8 .914-2.86.23-5.601.23-8.457.23-3.086 0-6.289-.23-9.488-.57a83 83 0 0 1-7.086-1.031c-2.055-.34-4.113-.801-6.168-1.258-1.031-.227-2.176-.57-3.203-.797-2.973-.8-6.055-1.602-9.028-2.516-1.488-.457-2.972-.914-4.457-1.258-2.172-.683-4.457-1.37-6.629-2.058-1.828-.57-3.656-1.14-5.37-1.711q-2.573-.86-5.145-1.715c-1.14-.344-2.285-.8-3.543-1.144-1.371-.457-2.856-1.028-4.227-1.485-1.027-.344-2.058-.687-2.972-1.027-1.942-.688-4-1.488-5.942-2.172-1.144-.457-2.285-.914-3.43-1.258-1.484-.57-3.085-1.144-4.57-1.828-1.601-.687-3.203-1.258-4.8-1.945-1.028-.457-2.06-.797-3.087-1.258-1.257-.57-2.628-1.027-3.886-1.598-1.028-.457-1.942-.8-2.969-1.258l-3.086-1.37c-.914-.344-1.832-.801-2.746-1.145a44 44 0 0 1-2.512-1.14c-.8-.345-1.715-.802-2.515-1.145-.914-.344-1.715-.801-2.512-1.141-1.031-.457-2.172-1.031-3.203-1.484-1.14-.575-2.285-1.032-3.426-1.602-1.258-.574-2.402-1.144-3.66-1.715-1.027-.457-2.055-1.027-3.082-1.484-54.172-26.973-102.172-63.086-143.09-106.746-2.055-2.172-5.71-.684-5.71 2.289l.112 154.398v12.57c0 7.317 3.543 14.06 9.598 18.172 38.172 24.801 83.773 39.543 132.914 39.543m0 0" fill="#3370ff"/>
                    <path d="M470.035 201.121c-18.285-9.031-38.86-14.059-60.687-14.059-12.914 0-25.485 1.829-37.371 5.141-1.372.344-2.743.8-4.114 1.258-.914.344-1.941.574-2.855.914-1.945.688-3.774 1.375-5.602 2.059-3.316 1.257-6.629 2.742-9.828 4.23-3.43 1.598-6.742 3.426-10.058 5.371a128 128 0 0 0-9.715 6.285c-2.285 1.602-4.457 3.2-6.512 4.914a154 154 0 0 0-6.86 5.828c-1.14 1.141-2.398 2.172-3.542 3.313l-6.055 6.059-4.344 4.343-4.8 4.684-4.57 4.46-4.802 4.798-11.086 11.086c-.687.687-1.37 1.37-2.058 1.945l-1.028 1.027c-.457.457-1.027 1.028-1.601 1.485-.57.57-1.14 1.031-1.711 1.601a244.4 244.4 0 0 1-49.828 35.313c1.027.457 2.168 1.027 3.199 1.488.8.34 1.715.797 2.512 1.14.8.344 1.715.801 2.515 1.145.801.344 1.602.684 2.516 1.14.914.345 1.828.802 2.742 1.145l3.086 1.371c1.027.457 1.942.801 2.969 1.258 1.258.57 2.629 1.028 3.887 1.598 1.03.46 2.058.8 3.086 1.258 1.601.687 3.199 1.258 4.8 1.945 1.485.57 3.086 1.14 4.57 1.828 1.145.457 2.286.914 3.43 1.258 1.946.684 4 1.484 5.946 2.172a81 81 0 0 1 2.968 1.027c1.371.457 2.856 1.028 4.23 1.485 1.141.343 2.286.8 3.544 1.14q2.567.86 5.14 1.719c1.829.57 3.657 1.14 5.372 1.71 2.171.688 4.457 1.376 6.628 2.06 1.489.457 2.973.914 4.457 1.257 2.973.914 5.942 1.715 9.032 2.512 1.027.344 2.168.574 3.199.8 2.055.458 4.113.915 6.172 1.259 2.398.457 4.683.8 7.082 1.03 3.203.34 6.402.571 9.488.571 2.856 0 5.715 0 8.457-.23 2.63-.227 5.371-.457 8-.914 3.656-.57 7.2-1.371 10.742-2.286 2.399-.683 4.688-1.37 6.973-2.285 2.172-.8 4.227-1.601 6.285-2.515 2.399-1.028 4.684-2.285 6.973-3.543 1.14-.57 2.168-1.258 3.312-1.942 1.028-.687 2.059-1.257 3.086-1.945 1.602-1.027 3.2-2.168 4.684-3.426a52 52 0 0 0 3.887-3.203c2.289-1.941 4.457-4 6.628-6.168 1.032-1.031 2.06-2.172 3.086-3.316 1.258-1.485 2.516-2.969 3.657-4.457.918-1.258 1.828-2.512 2.742-3.77 2.515-3.543 4.8-7.316 6.86-11.199l2.284-4.688 21.145-42.171v.113c6.742-14.742 16.226-28.113 27.656-39.426m0 0" fill="#133c9a"/>
                  </svg>
                </div>
                <div className="integration-content">
                  <h3>Lark</h3>
                  <p>{larkOverride?.connected
                    ? `Connected as app ${larkOverride.appId}${larkOverride.host === 'https://open.feishu.cn' ? ' · Feishu (CN)' : ' · Lark (Intl)'}${larkOverride.webhookReady ? ' · webhook ready' : ' · outbound only'} — this project's own app`
                    : "Connect this project's own Lark app — its events route to this project's Copilot"}</p>
                  {larkOverride?.connected && larkOverride?.eventRequestUrl && (
                    <p style={{ fontSize: 12, opacity: 0.85, marginTop: 4 }}>
                      Event Request URL (paste into Lark → Event Subscriptions):{' '}
                      <code
                        style={{ cursor: 'pointer', wordBreak: 'break-all' }}
                        title="Click to copy"
                        onClick={(e) => {
                          e.stopPropagation();
                          try {
                            navigator.clipboard.writeText(larkOverride.eventRequestUrl);
                            setToast?.({ show: true, message: 'Event Request URL copied', color: 'success' });
                          } catch { /* clipboard unavailable */ }
                        }}
                      >{larkOverride.eventRequestUrl}</code>
                    </p>
                  )}
                </div>
                <IonButton
                  className={`integration-button ${larkOverride?.connected ? 'connected' : 'connect'}`}
                  slot="end"
                  disabled={larkDisconnecting}
                  onClick={(e) => {
                    e.stopPropagation();
                    larkOverride?.connected ? disconnectLarkOverride() : setLarkModalOpen(true);
                  }}
                >
                  <IonIcon icon={larkOverride?.connected ? checkmarkCircle : linkOutline} slot="start" />
                  {larkOverride?.connected ? 'Connected' : 'Connect'}
                </IonButton>
              </IonItem>
            </>
          )}
        </CollapsibleCard>

      </div>

      {/* Project-scoped Lark connect — same shared modal, override submit. */}
      <LarkConnectModal
        isOpen={larkModalOpen}
        onClose={() => setLarkModalOpen(false)}
        onConnected={() => { setToast?.({ show: true, message: "Project Lark app connected.", color: 'success' }); loadLarkOverride(); }}
        overrideProjectId={projectId}
      />

      {/* Reused as-is — the invite flow itself is unchanged. */}
      <InviteModal
        isOpen={inviteOpen}
        onDismiss={() => setInviteOpen(false)}
        onSubmit={handleInvite}
        isSubmitting={inviteSubmitting}
        projectName={project?.name || ''}
        projectId={projectId}
        triggerRef={inviteBtnRef}
      />
    </div>
  );
};

export default ProjectSettings;
